var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOverview = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.333 8.1a.6.6 0 0 0 0-1.2v1.2ZM5 6.9a.6.6 0 0 0 0 1.2V6.9Zm0 1.2h3.333V6.9H5v1.2Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.917 9.167a2.083 2.083 0 1 1 0-4.167 2.083 2.083 0 0 1 0 4.167Z",
  stroke: "currentColor",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 4.4a.6.6 0 0 0 0 1.2V4.4Zm2.5 1.2a.6.6 0 0 0 0-1.2v1.2Zm0-1.2H5v1.2h2.5V4.4Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m15 15-3.75-2.5-2.083 1.667L5 10.834",
  stroke: "currentColor",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 16.9V3.1a.6.6 0 0 1 .6-.6h13.8a.6.6 0 0 1 .6.6v13.8a.6.6 0 0 1-.6.6H3.1a.6.6 0 0 1-.6-.6Z",
  stroke: "currentColor",
  strokeWidth: 1.2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOverview);
export default ForwardRef;